import * as Yup from 'yup'

const stripHtml = (html: string) => html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()

export const knowledgeBaseFormSchema = Yup.object().shape({
  title: Yup.string().trim().required('Name is required'),
  sectionId: Yup.number().typeError('Section is required').required('Section is required'),
  bodyHtml: Yup.string().test('not-empty', 'Text of Article is required', (value) => Boolean(value && stripHtml(value).length > 0)),
  isPinned: Yup.boolean(),
})
